<template>
<kt-span class="kt-nav__link-text">
    <slot></slot>
</kt-span>
</template>

<script>
export default {

}
</script>